module.exports = "../../app/cells/pages/questions/question_courses_cell.rb";